import { gql } from "@apollo/client";

export const competitorToMasterState = {
  brandCode: "",
  leastUom: "",
  Uom: "",
  conversion: "",
  vat: "",
  bas: "",
  cod: "",
  csh: "",
  smt: "",
  vansl: "",
};

export const competitorToMasterStateMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "brandCode": {
      if (value) {
        return {
          ...state,
          brandCode: value,
          brandCodeStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          brandCode: "",
          brandCodeStatus: "unchecked",
        };
      }
    }
    case "leastUom": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          leastUom: value,
          leastUomStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          leastUom: "",
          leastUomStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          leastUom: value,
          leastUomStatus: "error",
        };
      }
    }
    case "Uom": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          Uom: value,
          UomStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          Uom: "",
          UomStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          Uom: value,
          UomStatus: "error",
        };
      }
    }
    case "conversion": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          conversion: value,
          conversionStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          conversion: "",
          conversionStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          conversion: value,
          conversionStatus: "error",
        };
      }
    }
    case "bas": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          bas: value,
          basStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          bas: "",
          basStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          bas: value,
          basStatus: "error",
        };
      }
    }
    case "cod": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          cod: value,
          codStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          cod: "",
          codStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          cod: value,
          codStatus: "error",
        };
      }
    }
    case "smt": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          smt: value,
          smtStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          smt: "",
          smtStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          smt: value,
          smtStatus: "error",
        };
      }
    }
    case "csh": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          csh: value,
          cshStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          csh: "",
          cshStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          csh: value,
          cshStatus: "error",
        };
      }
    }
    case "vat": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          vat: value,
          vatStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          vat: "",
          vatStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          vat: value,
          vatStatus: "error",
        };
      }
    }
    case "vansl": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          vansl: value,
          vanslStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          vansl: "",
          vanslStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          vansl: value,
          vanslStatus: "error",
        };
      }
    }

    default:
      return state;
  }
};

export const addCompetitorToMaster = gql`
  mutation AddCompetitorToMaster($input: AddCompetitorToMasterInput!) {
    addCompetitorToMasterProduct(input: $input) {
      success
      error
      message
    }
  }
`;
